import { parseISOToDateTime } from '@calendly/datetime'
import { useState, useCallback } from 'react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { useSelector } from 'react-redux'
import { ArrowDownFillIcon, ArrowRightFillIcon, CalendarIcon } from '@calendly/ui/components/icons'
import { formatDate, formatTime } from '@calendly/booking-kit/services/time_format'

import { useI18n } from 'locales'
import {
  timezoneSelector,
  timeNotationSelector,
  groupedSelectedSpotsSelector
} from 'selectors'

import {
  SpotTimes,
  Wrapper,
  Control,
  Container,
  ExpandButton,
  GroupSpots,
  GroupSpotDetails,
  GroupSpotDate,
  GroupSpotTimes,
  TimezonePreview
} from './styles'

const useToggleState = (initialState) => {
  const [value, setValue] = useState(initialState)

  const toggle = useCallback(() => setValue((currentValue) => !currentValue), [])

  return [value, toggle]
}

const CollapsibleSpotTimes = ({ isCentered }) => {
  const { i18n } = useI18n()
  const timezone = useSelector(timezoneSelector)
  const timeNotation = useSelector(timeNotationSelector)
  const groupedSelectedSpots = useSelector(groupedSelectedSpotsSelector)
  const selectedSpotsDates = Object.keys(groupedSelectedSpots).sort()
  const selectedSpotsCount = Object.values(groupedSelectedSpots).flat().length
  const [isExpanded, toggleExpanded] = useToggleState(false)

  const formatSpotTime = (spot) => formatTime(spot, timeNotation)

  const renderSpotsPerDay = (date) => {
    const formattedDate = formatDate(parseISOToDateTime(date), i18n.t('time.formats.date_extra'))
    const sortedSpots = groupedSelectedSpots[date].sort()

    return (
      <GroupSpotDetails key={date}>
        <GroupSpotDate>
          {formattedDate}
        </GroupSpotDate>
        <GroupSpotTimes>
          {sortedSpots.map((spot) => formatSpotTime(spot)).join(', ')}
        </GroupSpotTimes>
      </GroupSpotDetails>
    )
  }

  const isTablet = useDeviceType('isTablet')

  return (
    <SpotTimes centered={isCentered || isTablet}>
      <Wrapper>
        <Control>
          <CalendarIcon size="large" />
          <ExpandButton onClick={toggleExpanded}>
            {i18n.t('booking.templates.poll.preferred_times', {
              count: selectedSpotsCount
            })}
            {isExpanded ? <ArrowDownFillIcon /> : <ArrowRightFillIcon />}
          </ExpandButton>
        </Control>
        {isExpanded && (
          <Container>
            <GroupSpots>
              {selectedSpotsDates.map((date) => renderSpotsPerDay(date))}
            </GroupSpots>
          </Container>
        )}
        {isExpanded && (
        <TimezonePreview timezone={timezone} />
        )}
      </Wrapper>
    </SpotTimes>
  )
}

export default CollapsibleSpotTimes
